module.exports = __webpack_public_path__ + "static/media/Crabrawler_gaussian2.73907914.png";